import * as _ from 'lodash';
import Intersects from 'intersects';

import SoundController from '@/assets/js/SoundController';
import Utils from '@/assets/js/Utils';

import AreaObject from '@/assets/js/game/AreaObject';
import GameManager from '@/assets/js/game/GameManager';
import Player from '@/assets/js/game/Player';
import ScoreAnimation from '@/assets/js/game/ScoreAnimation';

const HIT_AREA_DIAMETER_1 = 80;
const HIT_AREA_DIAMETER_2 = 120;
const HIT_AREA_DIAMETER_3 = 120;
const HIT_AREA_DIAMETER_4 = 120;
const ABSORB_SPEED = 0.15;

export default class AreaObjectItem extends AreaObject {
  constructor(objectData, x, y) {
    const image = objectData.image;
    const width = objectData.width;
    const height = objectData.height;
    super(objectData.id, width, height, x, y, image);
    this.isVisible = true;
    this.isAbsorb = false;
  }

  setHitAreaSize() {
    this.hitArea.radius = GameManager.calcRatio(this.hitAreaDaimeter) * 0.5;
    this.hitArea.x = this.sprite.x + this.sprite.width * 0.5;
    this.hitArea.y = this.sprite.y + this.sprite.height * 0.5;
    // this.hitArea.alpha = 0.4;
    // this.hitArea
    //   .beginFill(0xff00ff)
    //   .drawCircle(0, 0, this.hitArea.radius)
    //   .endFill();
  }

  update(delta, viewPositionX) {
    if (!this.isVisible) return;

    const gameWidth = GameManager.calcRatio(GameManager.gameWidth);
    const isShow =
      viewPositionX + gameWidth + gameWidth >= this.x - this.width * 0.5;
    if (!isShow) return;

    const isCollisionItem = Intersects.ellipseCircle(
      Player.hitArea.x + viewPositionX,
      Player.hitArea.y,
      Player.hitArea.rx,
      Player.hitArea.ry,
      this.hitArea.x,
      this.hitArea.y,
      this.hitArea.radius
    );

    if (isCollisionItem) this._collision();

    if (!this.isAbsorb && Player.isAbsorb) {
      const isAbsorbItem = Intersects.ellipseCircle(
        Player.absorbArea.x + viewPositionX,
        Player.absorbArea.y,
        Player.absorbArea.rx,
        Player.absorbArea.ry,
        this.hitArea.x,
        this.hitArea.y,
        this.hitArea.radius
      );
      if (isAbsorbItem) this._absorb();
    }

    if (this.isAbsorb) {
      this._absorbUpdate(delta, viewPositionX);
    }
  }

  get hitAreaDaimeter() {
    if (this.id === 1) return HIT_AREA_DIAMETER_1;
    if (this.id === 2) return HIT_AREA_DIAMETER_2;
    if (this.id === 3) return HIT_AREA_DIAMETER_3;
    if (this.id === 4) return HIT_AREA_DIAMETER_4;
    return HIT_AREA_DIAMETER_4;
  }

  _collision() {
    this.isVisible = false;
    this.container.parent.removeChild(this.container);
    if (this.id === 1) {
      GameManager.addScore(1);
      SoundController.play('se_player_get_happyturn');
      ScoreAnimation.start();
      return;
    }
    if (this.id === 2) {
      SoundController.play('se_player_get_item');
      GameManager.addLife();
      return;
    }
    if (this.id === 3) {
      SoundController.play('se_player_get_item');
      GameManager.absorb();
      return;
    }
    if (this.id === 4) {
      SoundController.play('se_player_get_item');
      GameManager.powder250();
      return;
    }
  }

  _absorb() {
    this.isAbsorb = true;
    this.sprite.totalTime = 0;
    this.sprite.startPosition = { x: this.sprite.x, y: this.sprite.y };
  }

  _absorbUpdate(delta, viewPositionX) {
    this.sprite.totalTime += delta;
    let timeFraction = Utils.msToSecond(this.sprite.totalTime) / ABSORB_SPEED;
    if (timeFraction > 1) timeFraction = 1;
    const progress = Utils.timing('quad', timeFraction);

    const goalX = Player.centerX + viewPositionX;
    const goalY = Player.centerY;

    const distanceX = goalX - this.sprite.startPosition.x;
    const distanceY = goalY - this.sprite.startPosition.y;

    this.sprite.x = this.sprite.startPosition.x + distanceX * progress;
    this.sprite.y = this.sprite.startPosition.y + distanceY * progress;

    this.hitArea.x = this.sprite.x + this.sprite.width * 0.5;
    this.hitArea.y = this.sprite.y + this.sprite.height * 0.5;
  }
}
